:host {
  --cms-container-background-color: var(--cms-semanticColors-transparency-strong-background);
  display: block;
  max-height: px-to-rem(700);
  padding: 0;
  width: 100%;
  margin-bottom: var(--cms-components-mb);
  background-color: var(--cms-container-background-color);
}

.hero-teaser-inner {
  display: grid;
  gap: var(--cms-grid-gap);
  height: var(--cms-grid-row-height);
  grid-template-columns: var(--cms-grid-template-columns);
}

cms-headline {
  --cms-font-size: var(--cms-adaptive-special-headline-size);
}

.grid-item {
  grid-area: var(--cms-default-grid-area);
}

.grid-item a {
  text-decoration: none;
  color: var(--cms-semanticColors-primary-textOnBackground);
}

.hero-teaser-image {
  max-height: px-to-rem(700);
}

.headlines-container {
  position: relative;
  width: 100%;
}

.headlines-wrapper {
  box-sizing: border-box;
  margin: 0 1rem;
  margin-top: -2rem;
  padding: var(--cms-spacing-100) var(--cms-spacing-200);
  position: relative;
  width: calc(100% - 2rem);
  z-index: 0;
  background-color: var(--cms-semanticColors-primary-background);
}

.subheadline-wrapper {
  color: var(--cms-semanticColors-primary-textOnBackground);
  font-family: var(--cms-brandfont2);
  margin-bottom: 0;
  font-size: var(--cms-adaptive-special-subheading-size);
  line-height: var(--cms-line-height-133);
  display: inline-flex;
  align-items: center;
  font-weight: var(--cms-heading-base-font-weight);
}

@include media-width($breakpoint-sm) {
  .headlines-wrapper {
    bottom: var(--cms-spacing-100);
    position: absolute;
    width: auto;
  }
}

@include media-width($breakpoint-md) {
  .headlines-container {
    max-width: var(--cms-container-max-width);
    margin: auto;
  }

  .headlines-wrapper {
    bottom: var(--cms-spacing-400);
  }
}

@media (min-width: 120rem) {
  .hero-teaser-inner {
    max-width: 120rem;
    margin: auto;
  }

  :host {
    padding-top: var(--cms-spacing-200);
  }
}